import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LoginService } from '../../../../../services/login.service';
import { FilaAtendimentoManagerService } from '../../../../../services/fila-atendimento-manager.service';
import { ChatService } from '../../../../../services/chat.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { PesquisaComponent } from '../../../componetes-comum/pesquisa/pesquisa.component';
import { ContatoEmpresaService } from '../../../../../services/contato-empresa.service';
import { HttpResponse } from '@angular/common/http';
import { MessageFormat } from '../fila-atendimento.component';

export interface EnviaMensagem {
  responseMessage?: HttpResponse<any>,
  emAtendimento: boolean,
  usuarioAtendente?: string
}

@Component({
  selector: 'ngx-envia-mensagem',
  templateUrl: './envia-mensagem.component.html',
  styleUrls: ['./envia-mensagem.component.scss']
})
export class EnviaMensagemComponent implements OnInit {

  formularioContato: FormGroup
  filtrarContatos
  isClosing: boolean = false;
  showAssunto: boolean = false;
  isClosingAssunto: boolean = false;
  contatoSelecionado
  showListaContato: boolean = true;
  usuarioLogado: any;
  EquipeChatPrincipal: any;
  SubEquipePrincipal: any;
  ListaContatos: any[] = [];
  NomeContato
  Conversa;

  constructor(private fb: FormBuilder,
    private loginService: LoginService,
    private FilaManagerService: FilaAtendimentoManagerService,
    private chatService: ChatService,
    public _snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private contatoService: ContatoEmpresaService,
    private dialogRef: MatDialogRef<EnviaMensagemComponent>
  ) {

    this.formularioContato = this.fb.group({
      idCliente: [null],
      Cliente: [null],
      idContato: [null],
      Contato: [null],
      nomeUsuario: [null],
      TelefoneWpp: [null],
      Departamento: [null],
      Assunto: [``]
    })

    this.Conversa = [{
      text: `${this.formularioContato.value.Assunto}`,
      date: new Date().toISOString(),
      reply: false,
      type: "text",
      user: {
        name: ""
      }
    }]

  }

  ngOnInit(): void {
    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos();
    this.SubEquipePrincipal = this.FilaManagerService.idEquipeChat$.subscribe(valor => {
      this.EquipeChatPrincipal = valor
    })

    var AssuntoControl = this.formularioContato.controls.Assunto
    var ContatoControl = this.formularioContato.controls.Contato

    ContatoControl.valueChanges.subscribe(data => {
      this.Conversa[0].text = `Olá ${this.NomeContato}\n
Me chamo ${this.usuarioLogado.Nome}, do(a) ${this.EquipeChatPrincipal.Departamento}.

Por favor, me retorne neste número assim que possível, preciso falar sobre: **

Aguardo retorno, obrigado!`
    })

    AssuntoControl.valueChanges.subscribe(data => {
      this.Conversa[0].text = `Olá ${this.NomeContato}\n
Me chamo ${this.usuarioLogado.Nome}, do(a) ${this.EquipeChatPrincipal.Departamento}.

Por favor, me retorne neste número assim que possível, preciso falar sobre: *${data}*

Aguardo retorno, obrigado!`
    })
  }

  selecionaContato(contato: MatAutocompleteSelectedEvent) {

    this.contatoSelecionado = contato.option.value
    this.NomeContato = this.contatoSelecionado.Contato
    this.formularioContato.patchValue({
      Contato: `${this.contatoSelecionado.Contato}` + ' - ' + `${this.contatoSelecionado.Telefone}`,
      nomeUsuario: this.usuarioLogado.Nome,
      Telefone: this.contatoSelecionado.TelefoneWpp,
      Departamento: this.EquipeChatPrincipal.Departamento
    })

  }

  iniciarConversa() {
    this.isClosing = true;
    setTimeout(() => {
      this.showListaContato = false;
      this.isClosing = false;
      this.showAssunto = true
    }, 300); // Tempo de transição
    // this.limparCampos();
  }

  fecharIniciarConversa() {
    this.isClosing = true
    this.showAssunto = false;
    setTimeout(() => {
      this.isClosing = false;
      this.showListaContato = true;
    })
  }

  enviaPrimeiraMensagem() {
    const messageformat: MessageFormat = {
      phoneNumberId: this.EquipeChatPrincipal.PhoneNumberID,
      telefone: this.contatoSelecionado.TelefoneWpp,
      nomeCliente: this.contatoSelecionado.Contato,
      nomeUsuario: this.formularioContato.value.nomeUsuario,
      Departamento: this.EquipeChatPrincipal.Departamento,
      Assunto: this.formularioContato.value.Assunto,
      idEquipeChat: this.EquipeChatPrincipal.IdEquipeChat,
      idCliente: this.formularioContato.value.idCliente,
      UsuarioAtendente: this.usuarioLogado.Nome,
      EmAtendimento: false
    }
    this.chatService.enviaPrimeiraMensagem(messageformat)
      .toPromise()
      .then((response: EnviaMensagem) => {
        console.log(response)
        console.log(response.emAtendimento)
        messageformat.EmAtendimento = response.emAtendimento
        if (response.emAtendimento == false) {
          this._snackBar.open('Mensagem enviada, aguardando retorno do cliente. ✅', 'Fechar', { duration: 5000 })
          this.fecharIniciarConversa();
          setTimeout(() => {
            this.showListaContato = false;
            this.isClosing = false;
          }, 300);
          this.formularioContato.patchValue({
            Assunto: '',
          })
          this.dialogRef.close(messageformat);
        }
        else{
          this._snackBar.open(`O Cliente já está em atendimento com o usuário ${response.usuarioAtendente}`, 'Fechar', { duration: 5000 })
        }
      }).catch(err => {
        this._snackBar.open(`Não foi possível enviar mensagem para o cliente: ${err}`, 'Fechar', { duration:20000 })
      })
    console.log(messageformat)
  }
  public BuscarCliente() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      componente: "Cliente",
      condicaoQuery: `Cliente.status <> 'Inativo'`
    };

    this.matDialog
      .open(PesquisaComponent, dialogConfig)
      .afterClosed()
      .subscribe((cliente) => {
        if (cliente) {
          this.formularioContato.patchValue({
            Contato: null,
            nomeUsuario: null,
            Telefone: null,
            Departamento: null
          })
          this.formularioContato.patchValue({
            idCliente: cliente.Id,
            Cliente: cliente.Nome,
          });
          this.contatoService.getContatoChat(cliente.Id)
            .toPromise()
            .then((response: any) => {
              this.filtrarContatos = response
              this.ListaContatos = response
            })
        }
      });
  }

  abrirListaContato() {
    if (this.showListaContato) {
      this.isClosing = true;
      setTimeout(() => {
        this.showListaContato = false;
        this.isClosing = false;
      }, 300); // Tempo de transição
    } else {
      this.showListaContato = true;
    }
  }
}
